import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    withdrawl: {},
    uloader: false,
    loading: false,
    withdrawls: [],
    payments: null,
    payment: null,
}

export const withdrawReq = createAsyncThunk('withdrawReq', async ({ page, status, country, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/withdraw/list?page=${page}&status=${status}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const userWithdrawReq = createAsyncThunk('userWithdrawReq', async ({ page, user }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/user/withdraw/${user}/list?page=${page}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const udpateWithdrawReq = createAsyncThunk('udpateWithdrawReq', async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/withdraw/update/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res.data.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleWithdrawReq = createAsyncThunk('singleWithdrawReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/withdraw/status/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const paymentsReq = createAsyncThunk('paymentsReq', async ({ page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/payments?page=${page}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const paymentsInfoReq = createAsyncThunk('paymentsInfoReq', async ({ id, type }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/payments/${type}/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const WithdrawlSlice = createSlice({
    name: 'withdrawlSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(withdrawReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.withdrawls = []
            return state
        })
        builder.addCase(withdrawReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.withdrawls = action.payload.data?.withdrawls
            return state
        })
        builder.addCase(withdrawReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.withdrawls = []
            state.error = 'Error occured'
        })

        builder.addCase(userWithdrawReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.current = 0
            state.withdrawls = []
            return state
        })
        builder.addCase(userWithdrawReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.withdrawls = action.payload.data?.withdrawls
            return state
        })
        builder.addCase(userWithdrawReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.current = 0
            state.withdrawls = []
            state.error = 'Error occured'
        })
        builder.addCase(singleWithdrawReq.pending, (state, action) => {
            state.loading = true
            state.withdrawl = {}
            return state
        })
        builder.addCase(singleWithdrawReq.fulfilled, (state, action) => {
            state.loading = false
            state.withdrawl = action.payload.data
            return state
        })
        builder.addCase(singleWithdrawReq.rejected, (state, action) => {
            state.loading = false
            state.withdrawl = {}
            state.error = 'Error occured'
        })

        builder.addCase(udpateWithdrawReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(udpateWithdrawReq.fulfilled, (state, action) => {
            state.uloader = false
            state.withdrawl = action.payload.data
            return state
        })
        builder.addCase(udpateWithdrawReq.rejected, (state, action) => {
            state.uloader = false
            state.withdrawl = {}
            state.error = 'Error occured'
        })

        builder.addCase(paymentsReq.pending, (state, action) => {
            state.total = 0
            state.pages = 0
            state.current = 0
            state.loading = true
            state.payments = null
            return state
        })
        builder.addCase(paymentsReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.payments = action.payload.data?.payments
            return state
        })
        builder.addCase(paymentsReq.rejected, (state, action) => {
            state.total = 0
            state.pages = 0
            state.current = 0
            state.loading = false
            state.payments = null
            state.error = 'Error occured'
        })

        builder.addCase(paymentsInfoReq.pending, (state, action) => {
            state.loading = true
            state.payment = null
            return state
        })
        builder.addCase(paymentsInfoReq.fulfilled, (state, action) => {
            state.loading = false
            state.payment = action.payload.data
            return state
        })
        builder.addCase(paymentsInfoReq.rejected, (state, action) => {
            state.loading = false
            state.payment = null
            state.error = 'Error occured'
        })

        builder.addCase('LOGOUT', () => initialState)
    }
})

export default WithdrawlSlice.reducer